import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';

import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';


import badBank from '../../images/badBanking.jpg';

import swiftReader from '../../images/swiftReaderDesktop.jpg'
import vueForm from '../../images/VueTickets.jpg'
import dash from '../../images/dash.jpg'
import splinePic from '../../images/3dSpline.png'
import busPic from '../../images/busPic.png'

import mobileBank from '../../images/bankMobile.jpg';

import mobileSwift from '../../images/swiftReaderMobile.jpg'
import mobileDash from '../../images/mobileDash.jpg'
import mobileAng from '../../images/angularPhone.jpg'
import mobileBus from '../../images/busPic.jpg'

import Project from '../../components/projects/Project';


import '../../App.css';

import './projects.css';

function Projects() {

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    // deployment functions
    const bankLink = (e) => {
        e.preventDefault()
        window.open('https://ian-grayfullstackbankingapplication.s3.amazonaws.com/index.html')
      }
    const swiftLink = (e) => {
        e.preventDefault()
        window.open('https://swiftreader-814f4.web.app/')
      }
    const vueLink = (e) => {
        e.preventDefault()
        window.open('https://ianzgray.github.io/Cool_Vue_Example/')
      }
    const dashLink = (e) => {
        e.preventDefault()
        window.open('https://glowing-yeot-30560d.netlify.app/')
      }
    const angLink = (e) => {
        e.preventDefault()
        window.open('https://jovial-sorbet-acad26.netlify.app/')
      }
    const splineLink = (e) => {
        e.preventDefault()
        window.open('https://grand-buttercream-f36458.netlify.app/')
      }
    const busLink = (e) => {
        e.preventDefault()
        window.open('https://ianzgray.github.io/Bus-Invaders/')
      }
    //   mobile deployment functions

    const bankMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://ian-grayfullstackbankingapplication.s3.amazonaws.com/index.html'
      }
    const swiftMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://swiftreader-814f4.web.app/'
      }
    const vueMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://ianzgray.github.io/Cool_Vue_Example/'
      }
    const dashMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://glowing-yeot-30560d.netlify.app/'
      }
    const angMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://jovial-sorbet-acad26.netlify.app/'
      }
    const splineMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://grand-buttercream-f36458.netlify.app/'
      }
    const busMobileLink = (e) => {
        e.preventDefault()
        window.location = 'https://ianzgray.github.io/Bus-Invaders/'
      }

    const swiftParagraph = `A front-end reading application that converts text into a rapid-display format to improve reading speed. Supports user-uploaded content and includes a built-in library of novels. Uses local storage to track user progress and settings without requiring a backend.`
    const badBankParagraph = `A full-stack banking application that allows a user to create an account, log in, and deposit/withdraw money. The app utilizes JSON web tokens for authentication. Login status saved in local storage.`
    const vueFormParagraph = `This dynamic form was created using Vue 3 and displays multiple UI elements designed to guide the user through the ordering process.`
    const dashParagraph = `An example of a business dashboard that utilizes a game-centric theme. Features include a functional Calendar, Kanban board, Text Editor, and Color Picker. There are also various graphs and charts, and two character creation pages allowing the user to update and save a personalized, 3D Metaverse Avatar, or 2D character. This was designed using TailwindCSS and utilizes SyncFusion and React-icons.`
    const angParagraph = `This is a multi-tool with a cell phone design that was made in Angular. This project showcases a few smaller angular apps housed within the cell-phone like design. Apps include versions of a Calculator, Web Browser, Banking App, Email, To-Do List, Icon Theme Changer, and App Adder. Styled with Tailwind CSS.`
    const splineParagraph = `An example of a physics based 3D interface encorporated into a website. The user can control an objectin 3D space and interact with other objects based on their collision types. This was designed using Spline, incorporated into the site using Vanilla JS, and Styled with CSS.`
    const busParagraph = `A real-time transit tracking application that visualizes bus locations and route data in an interactive interface. The app processes live data and updates the UI dynamically to reflect system changes. Built with a focus on translating real-world data into a clear and usable user experience.`


    // const projectsArray = [
    //     {
            
    //     },
    // ]

  return (
    <section className="pages" id="projects">
    <Container fluid >
        <div className="featured-view">
        <h1 className="mobile-big-header">Featured Project</h1>
        <h1 className="big-header reveal">Featured Project</h1>

        {/* Mobile View */}
        <Carousel id="mobile-caro" activeIndex={index} onSelect={handleSelect}>
            
            {/* <Carousel.Item onClick={ dashMobileLink } style={{width: '100vw'}}>
                <div className="fog"></div>
                <img src={mobileDash} alt="Dash Reader"  className="mobile-pics"/>

                <Carousel.Caption >
                    <h1 className="mobile-header">Metaverse Dashboard</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>With Functional Kanban Board, Calendar, and Ready Player Me Character Creator</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{dashParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>React.js, Tailwind CSS, JavaScript, HTML, Node.js</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item onClick={ angMobileLink } style={{width: '100vw'}}>
                <div className="fog"></div>
                <img src={mobileAng} alt="Multi-Tool App"  className="mobile-pics"/>

                <Carousel.Caption >
                    <h1 className="mobile-header">Multi-Tool App</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>Angular Cell Phone Simulation</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{angParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>Angular, Tailwind CSS, TypeScript, HTML, Node.js</p>
                </Carousel.Caption>
            </Carousel.Item> */}


            <Carousel.Item onClick={ swiftMobileLink } style={{width: '100vw'}}>
            <div className="fog"></div>
            <img src={mobileSwift} alt="Swift Reader"  className="mobile-pics"/>

                <Carousel.Caption >
                    <h1 className="mobile-header">Swift Reader</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>Study Aide and Document Reader</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{swiftParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>Firebase, React.js, Node.js, yarn, JavaScript, CSS, HTML</p>
                </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item onClick={ splineMobileLink } style={{width: '100vw'}}>
                <div className="fog"></div>
                <img src={splinePic} alt="3D Playground"  className="mobile-pics"/>

                <Carousel.Caption >
                    <h1 className="mobile-header">3D Playground</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>Physics based interactive interface</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{splineParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>Spline, JavaScript, HTML, CSS</p>
                </Carousel.Caption>
            </Carousel.Item>


            <Carousel.Item onClick={ busMobileLink } style={{width: '100vw'}}>
            <div className="fog"></div>
            <img src={mobileBus} alt="Bus Tracker"  className="mobile-pics"/>

                <Carousel.Caption >
                    <h1 className="mobile-header">Bus Tracker</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>Real-Time Bus Tracking Application</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{busParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>REST API, JavaScript, CSS, HTML</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item onClick={ bankMobileLink } style={{width: '100vw'}}>
            <div className="fog"></div>
            <img src={mobileBank} alt="Bad Bank"  className="mobile-pics"/>

                <Carousel.Caption>
                    <h1 className="mobile-header">Bad Bank</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>Full Stack Bank Project MIT</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{badBankParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>React.js, Node.js, Express.js, Mongo DB, Mongooese, Mongo Atlas, npm, Bootstrap, JWT, Bcrypt, JavaScript, CSS, HTML</p>
                </Carousel.Caption>
            </Carousel.Item>
            {/* <Carousel.Item onClick={ vueMobileLink } style={{width: '100vw'}}>
            <div className="fog"></div>
            <img src={vueForm} alt="Bad Bank"  className="mobile-pics"/>

                <Carousel.Caption>
                    <h1 className="mobile-header">Cool Vue Form</h1>
                    <h2 className="mobile-sub-header" style={{fontSize:'small'}}>Dynamic Form Component using Vue</h2>
                    <p className='mobile-p' style={{fontSize:'small'}}>{vueFormParagraph}</p>
                    <p className="mobile-languages" style={{fontSize:'small'}}>Vue3, Node.js, JavaScript, CSS, HTML, yarn</p>
                </Carousel.Caption>
            </Carousel.Item> */}
        </Carousel>

{/* Desktop and Tablet View */}
        
        {/* <Col className="project-rows" xs={{span: 8, offset: 3}}>
            <div id="tablet-view"  className='reveal proj-fade-right' >
                <div className="yellow-box" onClick={ dashLink }>
                    <div className='bio'>
                    <h1 className="header left">Metaverse Dashboard</h1>
                    <h2 className="sub-header left">With Functional Kanban Board, Calendar, and Ready Player Me Character Creator</h2>
                    <p>{dashParagraph}</p>
                    <p className="languages">React.js, Tailwind CSS, JavaScript, HTML, Node.js</p>
                    </div>
                    <div className="pic-border" >
                        <img src={dash} alt="Metaverse Dashboard" className="pics"/>
                    </div>
                </div>
            </div>
            <div id="desktop-view" className="reveal proj-fade-right" >
                <div className="yellow-box" onClick={ dashLink }>
                    <div className='bio'>
                    <h1 className="header left">Metaverse Dashboard</h1>
                    <h2 className="sub-header left">With Functional Kanban Board, Calendar, and Ready Player Me Character Creator</h2>
                    <p>{dashParagraph}</p>
                    <p className="languages">React.js, Tailwind CSS, JavaScript, HTML, Node.js</p>
                    </div>
                    <div className="pic-border" >
                        <img src={dash} alt="Metaverse Dashboard" className="pics"/>
                    </div>
                </div>
            </div>
        </Col>
        <Col className="project-rows" xs={{span: 8, offset: 1}}>
            <div id="tablet-view"  className='reveal proj-fade-left' >
                <div className="yellow-box" onClick={ angLink }>
                    <div className='bio'>
                    <h1 className="header left">Multi-Tool App</h1>
                    <h2 className="sub-header left">Angular Cell Phone Simulation</h2>
                    <p>{angParagraph}</p>
                    <p className="languages">Angular, Tailwind CSS, TypeScript, HTML, Node.js</p>
                    </div>
                    <div className="pic-border" >
                        <img src={mobileAng} alt="Multi-Tool App" className="pics"/>
                    </div>
                </div>
            </div>
            <div id="desktop-view" className="reveal proj-fade-left" >
                <div className="yellow-box" onClick={ angLink }>
                    <div className='bio'>
                    <h1 className="header left">Multi-Tool App</h1>
                    <h2 className="sub-header left">Angular Cell Phone Simulation</h2>
                    <p>{angParagraph}</p>
                    <p className="languages">Angular, Tailwind CSS, TypeScript, HTML, Node.js</p>
                    </div>
                    <div className="pic-border" >
                        <img src={mobileAng} alt="Multi-Tool App" className="pics"/>
                    </div>
                </div>
            </div>
        </Col> */}
        <Col className="project-rows" xs={{span: 8, offset: 3}}>
            <div id="tablet-view" className='reveal proj-fade-right' >
                <div className="yellow-box" onClick={ swiftLink } >
                    <div className='bio'>
                    <h1 className="header left">Swift Reader</h1>
                    <h2 className="sub-header left">Study Aide and Document Reader</h2>
                    <p>{swiftParagraph}</p>
                    <p className="languages">Firebase, React.js, Node.js, yarn, JavaScript, CSS, HTML</p>
                    </div>
                    <div  className="pic-border" >
                        <img src={swiftReader} alt="Swift Reader" className="pics"/>
                    </div>
                </div>
            </div>
            <div id="desktop-view" className="reveal proj-fade-right" >
                <div className="yellow-box" onClick={ swiftLink }>
                    <div className='bio'>
                        <h1 className="header left">Swift Reader</h1>
                        <h2 className="sub-header left">Study Aide and Document Reader</h2>
                        <p>{swiftParagraph}</p>
                        <p className="languages">Firebase, React.js, Node.js, yarn, JavaScript, CSS, HTML</p>
                    </div>
                    <div className="pic-border" >
                        <img src={swiftReader} alt="Swift Reader" className="pics"/>
                    </div>
                </div>
            </div>
        </Col>

        <Col className="project-rows" xs={{span: 8, offset: 1}}>
            <div id="tablet-view"  className='reveal proj-fade-left' >
                <div className="yellow-box" onClick={ splineLink }>
                    <div className='bio'>
                    <h1 className="header left">3D Playground</h1>
                    <h2 className="sub-header left">Physics based interactive interface</h2>
                    <p>{splineParagraph}</p>
                    <p className="languages">Spline, JavaScript, HTML, CSS</p>
                    </div>
                    <div className="pic-border" >
                        <img src={splinePic} alt="3D Playground" className="pics"/>
                    </div>
                </div>
            </div>
            {/* <Project id='tablet-view', link=splineLink, title, subTitle, para, lang, img, alt, offset=1 /> */}
            <div id="desktop-view" className="reveal proj-fade-left" >
                <div className="yellow-box" onClick={ splineLink }>
                    <div className='bio'>
                    <h1 className="header left">3D Playground</h1>
                    <h2 className="sub-header left">Physics based interactive interface</h2>
                    <p>{splineParagraph}</p>
                    <p className="languages">Spline, JavaScript, HTML, CSS</p>
                    </div>
                    <div className="pic-border" >
                        <img src={splinePic} alt="3D Playground" className="pics"/>
                    </div>
                </div>
            </div>
        </Col>


        <Col className="project-rows" xs={{span: 8, offset: 3}}>
            <div id="tablet-view" className='reveal proj-fade-right' >
                <div className="yellow-box" onClick={ busLink } >
                    <div className='bio'>
                    <h1 className="header left">Bus Tracker</h1>
                    <h2 className="sub-header left">Real-Time Bus Tracking Application</h2>
                    <p>{busParagraph}</p>
                    <p className="languages">REST API, JavaScript, CSS, HTML</p>
                    </div>
                    <div  className="pic-border" >
                        <img src={busPic} alt="Bus Tracker" className="pics"/>
                    </div>
                </div>
            </div>
            <div id="desktop-view" className="reveal proj-fade-right" >
                <div className="yellow-box" onClick={ busLink }>
                    <div className='bio'>
                        <h1 className="header left">Bus Tracker</h1>
                        <h2 className="sub-header left">Real-Time Bus Tracking Application</h2>
                        <p>{busParagraph}</p>
                        <p className="languages">REST API, JavaScript, CSS, HTML</p>
                    </div>
                    <div className="pic-border" >
                        <img src={busPic} alt="Bus Tracker" className="pics"/>
                    </div>
                </div>
            </div>
        </Col>

        
        <Col className="project-rows" xs={{span: 8, offset: 1}}>
            <div id="tablet-view"  className='reveal proj-fade-left' >
                <div className="yellow-box" onClick={ bankLink }>
                    <div className='bio'>
                    <h1 className="header left">Bad Bank</h1>
                    <h2 className="sub-header left">Front-Facing Bank Project</h2>
                    <p>{badBankParagraph}</p>
                    <p className="languages">React.js, Node.js, Express.js, Mongo DB, Mongooese, Mongo Atlas, npm, Bootstrap, JWT, Bcrypt, JavaScript, CSS, HTML</p>
                    </div>
                    <div className="pic-border" >
                        <img src={badBank} alt="Bad Bank" className="pics"/>
                    </div>
                </div>
            </div>
            <div id="desktop-view" className="reveal proj-fade-left" >
                <div className="yellow-box" onClick={ bankLink }>
                    <div className='bio'>
                    <h1 className="header left">Bad Bank</h1>
                    <h2 className="sub-header left">Front-Facing Bank Project</h2>
                    <p>{badBankParagraph}</p>
                    <p className="languages">React.js, Node.js, Express.js, Mongo DB, Mongooese, Mongo Atlas, npm, Bootstrap, JWT, Bcrypt, JavaScript, CSS, HTML</p>
                    </div>
                    <div className="pic-border" >
                        <img src={badBank} alt="Bad Bank" className="pics"/>
                    </div>
                </div>
            </div>
        </Col>
        {/* <Col className="project-rows" xs={{span: 8, offset: 3}}>
            <div id="tablet-view" className='reveal proj-fade-right' >
                <div className="yellow-box" onClick={ vueLink } >
                    <div className='bio'>
                    <h1 className="header left">Cool Vue Form</h1>
                    <h2 className="sub-header left">Dynamic Form Component using Vue</h2>
                    <p>{vueFormParagraph}</p>
                    <p className="languages">Vue3, Node.js, yarn, JavaScript, CSS, HTML</p>
                    </div>
                    <div  className="pic-border" >
                        <img src={vueForm} alt="Vue Form" className="pics"/>
                    </div>
                </div>
            </div>
            <div id="desktop-view" className="reveal proj-fade-right" >
                <div className="yellow-box" onClick={ vueLink }>
                    <div className='bio'>
                        <h1 className="header left">Cool Vue Form</h1>
                        <h2 className="sub-header left">Dynamic Form Component using Vue</h2>
                        <p>{vueFormParagraph}</p>
                        <p className="languages">Vue3, Node.js, yarn, JavaScript, CSS, HTML</p>
                    </div>
                    <div className="pic-border" >
                        <img src={vueForm} alt="Vue Form" className="pics"/>
                    </div>
                </div>
            </div>
        </Col> */}

        </div>

        <div class="wave-projects">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" class="shape-fill"></path>
            </svg>
        </div>

    </Container>
    </section>
  )
}

export default Projects
